export default __webpack_public_path__ + "static/media/hotBreakfast.d353af1d.JPG";